import React, { useEffect, useState } from 'react';
import Motif from './Motif.js';
import sampleMotif from './input/motif2.json';

function getQueryParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

function MotifQuery() {
  const img = getQueryParam('img');
  const [motif, setMotif] = useState(null);
  const [loadError, setLoadError] = useState('');
  // const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (!img) {
      setMotif(sampleMotif);
      return;
    }

    fetch(`/motif/${encodeURIComponent(img)}.json`)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load motif');
        }
        return res.json();
      })
      .then((data) => setMotif(data))
      .catch((err) => {
        console.error(err);
        setLoadError('Unable to load this motif. Check the motif link and try again.');
      });
  }, [img]);

  // PDF download disabled for now.
  /*
  const handleDownloadPdf = async () => {

    if (!img) return;
  
    // Om den redan är true -> stäng av
    if (isDownloading) {
      setIsDownloading(false);
      return;
    }
  
    // annars starta download-läget
    setIsDownloading(true);
  
    try {
      const res = await fetch('http://localhost:3001/pdf', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ motifId: img })
      });
  
      if (!res.ok) {
        throw new Error('PDF generation failed');
      }
  
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = url;
      a.download = `motif-${img}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
  
      window.URL.revokeObjectURL(url);
  
    } catch (err) {
      console.error('PDF download error:', err);
    }
  };
  */

  if (!motif) {
    return <div>{loadError || 'Loading motif...'}</div>;
  }

  return (
    <div className="motif-page">
       <Motif input={motif} />
      {/* PDF download disabled for now.
       <section className={`download-info ${isDownloading ? "open" : "closed"}`}>
        {isDownloading === true ?   
        <section className="download-text">
        <h2>
          Download PDF Chart
          <img
            src="https://www.iconpacks.net/icons/1/free-information-icon-348-thumb.png"
            alt="Info icon"
            className="info-icon"
          />
        </h2>
        <p>This PDF chart does not contain neither instructions nor a color key.</p>
      </section> : null
      }

        <button
          className="download-button"
          aria-label="Download PDF"
          onClick={handleDownloadPdf}
        >
          {isDownloading ? (
            '...'
          ) : (
            <svg
            width="150"
            height="150"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Download icon"
          >
            <path
              d="M12 3V14M12 14L7 10M12 14L17 10M5 18V20H19V18"
              stroke="#1E1A1F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          )}
        </button>
      </section>
      */}
    </div>
  );
}

export default MotifQuery;